<template>
  <div>
    <div class="fab" :style="fabStyle" @click="openSheet">
      <img src="@/assets/icons/waiter-w.svg" class="fab-icon" :class="this.waiterCalled ? 'bell-effect-diagonal' : ''" alt="waiter" />
    </div>

    <div v-if="showSheet" class="overlay" @click="closeSheet"></div>

    <transition name="slide-up">
      <div v-if="showSheet" class="bottom-sheet">
        <div class="sheet-header">
          Appeler le serveur pour
        </div>

        <div
          v-for="reason in callWaiterReasons"
          :key="reason.code"
          class="sheet-item"
          @click="callWaiter(reason.code)"
        >
          <img
            v-if="reason.code === 1"
            src="@/assets/icons/bill.svg"
            height="20"
            class="mr-2"
          />
          <img
            v-else-if="reason.code === 0"
            src="@/assets/icons/clean-table.svg"
            height="20"
            class="mr-2"
          />
          <img
            v-else-if="reason.code === 2"
            src="@/assets/icons/help.svg"
            height="20"
            class="mr-2"
          />

          {{ reason.value }}
        </div>

        <div class="sheet-cancel" @click="closeSheet">
          Annuler
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ProcessingOrdersApi from "@/services/processing-orders-api";

export default {
  name: "FloatingCallWaiter",

  props: {
    bottom: {
      type: String,
      default: "20px"
    },
    right: {
      type: String,
      default: "20px"
    },
    left: {
      type: String,
      default: "20px"
    },
    size: {
      type: Number,
      default: 40
    },
    backgroundColor: {
      type: String,
      default: "#d11010"
    }
  },

  data() {
    return {
      showSheet: false,
      callWaiterReasons: [],
      waiterCalled: false,
    };
  },

  computed: {
    fabStyle() {
      return {
        position: "fixed",
        bottom: this.bottom,
        right: this.right,
        left: this.left,
        width: this.size + "px",
        height: this.size + "px",
        backgroundColor: this.backgroundColor
      };
    }
  },

  methods: {
    openSheet() {
      this.showSheet = true;
      this.findCallWaiterReason();
    },

    closeSheet() {
      this.showSheet = false;
    },

    findCallWaiterReason() {
      ProcessingOrdersApi
        .findCallWaiterReason(this.currentLang)
        .then(res => {
          this.callWaiterReasons = res || [];
        });
    },

    callWaiter(callWaiterReason){
      this.waiterCalled= true
      ProcessingOrdersApi.callWaiter(callWaiterReason).then(() =>{
          this.closeSheet();
          setTimeout(() => {
              this.waiterCalled = false;
          }, 2000);
          
      })
    },    

  }
};
</script>

<style scoped>
.fab {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0px 0px 10px rgb(255 255 255);
  z-index: 10001;
}

.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 10000;
}

.bottom-sheet {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 16px 16px 0 0;
  padding: 16px;
  z-index: 10002;
}

.sheet-header {
  text-align: center;
  font-weight: bold;
  margin-bottom: 12px;
}

.sheet-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

.sheet-item:hover {
  background: #f5f5f5;
}

.sheet-cancel {
  text-align: center;
  padding: 12px;
  color: red;
  font-weight: bold;
  cursor: pointer;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
}

.fab-icon { width: 27px; height: 27px; margin-bottom:3px; pointer-events: none; }


.bell-effect-diagonal {
  display: inline-block;
  transform-origin: center; /* pivot around center */
  animation: swing-diagonal 1s infinite ease-in-out;
}

@keyframes swing-diagonal {
  0%   { transform: rotate(45deg); }
  10%  { transform: rotate(60deg); }
  20%  { transform: rotate(35deg); }
  30%  { transform: rotate(55deg); }
  40%  { transform: rotate(40deg); }
  50%  { transform: rotate(50deg); }
  60%  { transform: rotate(42deg); }
  70%  { transform: rotate(48deg); }
  80%  { transform: rotate(44deg); }
  90%  { transform: rotate(46deg); }
  100% { transform: rotate(45deg); }
}
</style>
